const students = [
  {
    "first_name": "Elizabeth",
    "middle": "Ann",
    "last_name": "Andresen",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Mark",
    "middle": "H.",
    "last_name": "Arnold",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Carol",
    "middle": "Lynn",
    "last_name": "Bailey",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Gail",
    "middle": "Ann",
    "last_name": "Beans",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Constance",
    "middle": "J.",
    "last_name": "Behr",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Bonnie",
    "middle": "Lou",
    "last_name": "Bennett",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Patricia",
    "middle": "",
    "last_name": "Boerner",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Kevin",
    "middle": "D.",
    "last_name": "Bounds",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Linda",
    "middle": "Susan",
    "last_name": "Braun",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Deborah",
    "middle": "Lee",
    "last_name": "Brown",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Linda",
    "middle": "Mary",
    "last_name": "Bryan",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Deborah",
    "middle": "L.",
    "last_name": "Burns",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Harry",
    "middle": "",
    "last_name": "Burns",
    "school": "West",
    "": ""
  },
  {
    "first_name": "J.",
    "middle": "",
    "last_name": "Calahan",
    "school": "West",
    "": ""
  },
  {
    "first_name": "John",
    "middle": "Gerard",
    "last_name": "Cameron",
    "school": "West",
    "": ""
  },
  {
    "first_name": "James",
    "middle": "Barry",
    "last_name": "Carling",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Helen",
    "middle": "",
    "last_name": "Carlson",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Scott",
    "middle": "",
    "last_name": "Chadbourne",
    "school": "West",
    "": ""
  },
  {
    "first_name": "David",
    "middle": "George",
    "last_name": "Christ",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Janice",
    "middle": "Marcia",
    "last_name": "Clark",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Kristin",
    "middle": "Gail",
    "last_name": "Clements",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Daniel",
    "middle": "",
    "last_name": "Cohen",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Maeve",
    "middle": "Elizabeth",
    "last_name": "Cook",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Glenn",
    "middle": "",
    "last_name": "Cooper",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Betsy",
    "middle": "H.",
    "last_name": "Coulton",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Linda",
    "middle": "Lee",
    "last_name": "Cowan",
    "school": "West",
    "": ""
  },
  {
    "first_name": "B.",
    "middle": "",
    "last_name": "Cox",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Mary",
    "middle": "Beth",
    "last_name": "Crawford",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Gary",
    "middle": "R.",
    "last_name": "Dalrymple",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Thomas",
    "middle": "William",
    "last_name": "Davis",
    "school": "West",
    "": ""
  },
  {
    "first_name": "J.",
    "middle": "",
    "last_name": "Denslow",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Julie",
    "middle": "Lynn",
    "last_name": "DeStefano",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Carol",
    "middle": "Ann",
    "last_name": "Dick",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Malcolm",
    "middle": "I.",
    "last_name": "Dickinson",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Diana",
    "middle": "",
    "last_name": "Diebert",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Anne",
    "middle": "Megan",
    "last_name": "Dougherty",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Carol",
    "middle": "Ann",
    "last_name": "Douglass",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Robert",
    "middle": "",
    "last_name": "Downey",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Heather",
    "middle": "A.",
    "last_name": "Duff",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Donna",
    "middle": "",
    "last_name": "Dumm",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Betty",
    "middle": "",
    "last_name": "Dungan",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Christ",
    "middle": "L.",
    "last_name": "Erbe",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Joseph",
    "middle": "S.",
    "last_name": "Evans (III)",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Mike",
    "middle": "",
    "last_name": "Everett",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Donald",
    "middle": "F.",
    "last_name": "Fiedler",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Michael",
    "middle": "James",
    "last_name": "Firko",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Michele",
    "middle": "",
    "last_name": "Franklin",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Tyrone",
    "middle": "C.",
    "last_name": "Ganges",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Patricia",
    "middle": "Mari",
    "last_name": "Genova",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Donna",
    "middle": "L.",
    "last_name": "George",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Bonnie",
    "middle": "L.",
    "last_name": "Geremia",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Marylou",
    "middle": "",
    "last_name": "Gilmore",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Thomas",
    "middle": "Edwin",
    "last_name": "Grow",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Dorothy",
    "middle": "",
    "last_name": "Grumbecht",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Walter",
    "middle": "P.",
    "last_name": "Hansell",
    "school": "West",
    "": ""
  },
  {
    "first_name": "R.",
    "middle": "",
    "last_name": "Hicks",
    "school": "West",
    "": ""
  },
  {
    "first_name": "B.",
    "middle": "",
    "last_name": "Hinch",
    "school": "West",
    "": ""
  },
  {
    "first_name": "G.",
    "middle": "",
    "last_name": "Hinch",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Phyllis",
    "middle": "G.",
    "last_name": "Hodge",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Donald",
    "middle": "",
    "last_name": "Horvath",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Albert",
    "middle": "E.",
    "last_name": "Houk",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Carol",
    "middle": "A.",
    "last_name": "Jago",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Cathryn",
    "middle": "Carol",
    "last_name": "Jarin",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Charles",
    "middle": "M.",
    "last_name": "Jewell",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Arthur",
    "middle": "P.",
    "last_name": "Johnson",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Joyce",
    "middle": "Phoebe",
    "last_name": "Jones",
    "school": "West",
    "": ""
  },
  {
    "first_name": "J.",
    "middle": "",
    "last_name": "Kasak",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Paul",
    "middle": "J.",
    "last_name": "Keene",
    "school": "West",
    "": ""
  },
  {
    "first_name": "D.",
    "middle": "",
    "last_name": "Kirkland",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Klaus",
    "middle": "D.",
    "last_name": "Koch",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Cheryl",
    "middle": "Ann",
    "last_name": "Kriebel",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Virginia",
    "middle": "",
    "last_name": "Kuremsky",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Allen",
    "middle": "J.",
    "last_name": "Leets",
    "school": "West",
    "": ""
  },
  {
    "first_name": "T.",
    "middle": "",
    "last_name": "Major",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Lawrence",
    "middle": "D.",
    "last_name": "Mangin",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Sharon",
    "middle": "Jean",
    "last_name": "Melvin",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Jerry",
    "middle": "J.",
    "last_name": "Mendlowski",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Susan",
    "middle": "Linda",
    "last_name": "Muir",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Joyce",
    "middle": "Ann",
    "last_name": "Nigg",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Thomas",
    "middle": "Carter",
    "last_name": "Nisbet",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Mary",
    "middle": "E.",
    "last_name": "Nissley",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Jay",
    "middle": "Forest",
    "last_name": "Penniman",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Claude",
    "middle": "R.",
    "last_name": "Proulx",
    "school": "West",
    "": ""
  },
  {
    "first_name": "George",
    "middle": "Lester",
    "last_name": "Renner",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Richard",
    "middle": "",
    "last_name": "Rimmer",
    "school": "West",
    "": ""
  },
  {
    "first_name": "P.",
    "middle": "",
    "last_name": "Roth",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Kevin",
    "middle": "Lane",
    "last_name": "Rotzel",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Bruce",
    "middle": "Kent",
    "last_name": "Sanders",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Robb",
    "middle": "L.",
    "last_name": "Saunders",
    "school": "West",
    "": ""
  },
  {
    "first_name": "John",
    "middle": "",
    "last_name": "Schlosser",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Susan",
    "middle": "Elizabeth",
    "last_name": "Shafer",
    "school": "West",
    "": ""
  },
  {
    "first_name": "D.",
    "middle": "",
    "last_name": "Smith",
    "school": "West",
    "": ""
  },
  {
    "first_name": "R.",
    "middle": "A.",
    "last_name": "Smith",
    "school": "West",
    "": ""
  },
  {
    "first_name": "William",
    "middle": "R.",
    "last_name": "Squires",
    "school": "West",
    "": ""
  },
  {
    "first_name": "David",
    "middle": "Reid",
    "last_name": "Thornton",
    "school": "West",
    "": ""
  },
  {
    "first_name": "David",
    "middle": "S.",
    "last_name": "Tyson",
    "school": "West",
    "": ""
  },
  {
    "first_name": "William",
    "middle": "",
    "last_name": "VanPelt",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Charles",
    "middle": "George",
    "last_name": "Verro Jr.",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Carl",
    "middle": "D.",
    "last_name": "Weaver",
    "school": "West",
    "": ""
  },
  {
    "first_name": "George",
    "middle": "William",
    "last_name": "Wiley",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Patricia",
    "middle": "",
    "last_name": "Wishwanick",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Teresa",
    "middle": "R.",
    "last_name": "Zeidler",
    "school": "West",
    "": ""
  },
  {
    "first_name": "Diane",
    "middle": "H.",
    "last_name": "Anderson",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Cathleen",
    "middle": "J.",
    "last_name": "Benguerel",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Owen",
    "middle": "B.",
    "last_name": "Bennett",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Albert",
    "middle": "H.",
    "last_name": "Bennett (Jr.)",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Karen",
    "middle": "M.",
    "last_name": "Bishop",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Harry",
    "middle": "Logan",
    "last_name": "Bland",
    "school": "East",
    "": ""
  },
  {
    "first_name": "David",
    "middle": "G.",
    "last_name": "Borgeson",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Diedra",
    "middle": "L.",
    "last_name": "Bowles",
    "school": "East",
    "": ""
  },
  {
    "first_name": "David",
    "middle": "W.",
    "last_name": "Boyce",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Patricia",
    "middle": "",
    "last_name": "Brennecke",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Linda",
    "middle": "G.",
    "last_name": "Brown",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Michael",
    "middle": "Raymond",
    "last_name": "Brown",
    "school": "East",
    "": ""
  },
  {
    "first_name": "William",
    "middle": "R.",
    "last_name": "Callow",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Debbie",
    "middle": "L.",
    "last_name": "Chanco",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Diane",
    "middle": "S.",
    "last_name": "Clemens",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Susan",
    "middle": "Meredith",
    "last_name": "Cole",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Theresa",
    "middle": "Ruth Ann",
    "last_name": "DeHaven",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Ronald",
    "middle": "",
    "last_name": "Demusz",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Larry",
    "middle": "",
    "last_name": "Dickson",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Nancy",
    "middle": "Elizabeth",
    "last_name": "Dilworth",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Charles",
    "middle": "O.",
    "last_name": "Gensler",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Richard",
    "middle": "M.",
    "last_name": "Guy",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Frank",
    "middle": "",
    "last_name": "Hall",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Lois",
    "middle": "Renee",
    "last_name": "Halligan",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Donna",
    "middle": "Jane",
    "last_name": "Harris",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Jim",
    "middle": "R.",
    "last_name": "Hayne",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Robert",
    "middle": "V.",
    "last_name": "Heinle, Jr.",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Jane",
    "middle": "Elizabeth",
    "last_name": "Hershner",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Janice",
    "middle": "Marie",
    "last_name": "Hibbard",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Mary",
    "middle": "M.",
    "last_name": "Huestis",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Willam",
    "middle": "B.",
    "last_name": "Hunt",
    "school": "East",
    "": ""
  },
  {
    "first_name": "David",
    "middle": "K.",
    "last_name": "Huttenlock",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Ronald",
    "middle": "Scott",
    "last_name": "Jackson",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Carol",
    "middle": "Estelle",
    "last_name": "Joka",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Geraldine",
    "middle": "Marie",
    "last_name": "Knock",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Jean",
    "middle": "S.",
    "last_name": "Kummer",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Rosemarie",
    "middle": "",
    "last_name": "Lakata",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Kenneth",
    "middle": "G.",
    "last_name": "Lear",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Bernice",
    "middle": "",
    "last_name": "Leatherman",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Roseangela",
    "middle": "",
    "last_name": "Lisboa",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Constance",
    "middle": "Jeanne",
    "last_name": "Longhurst",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Kevin",
    "middle": "J.",
    "last_name": "Magner",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Edward",
    "middle": "John",
    "last_name": "Marcinik",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Holly",
    "middle": "",
    "last_name": "Maxson",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Patricia",
    "middle": "A.",
    "last_name": "Mendleson",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Dennis",
    "middle": "C.",
    "last_name": "Mill",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Lynn",
    "middle": "E.",
    "last_name": "Moore",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Carol",
    "middle": "",
    "last_name": "Mullen",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Maura",
    "middle": "Christine",
    "last_name": "Murphy",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Darlene",
    "middle": "Ruth",
    "last_name": "Myers",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Anna",
    "middle": "M.E.",
    "last_name": "Myerson",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Linda",
    "middle": "Marie",
    "last_name": "Nagle",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Victoria",
    "middle": "Ann",
    "last_name": "Neuhart",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Susan",
    "middle": "Jayne",
    "last_name": "Oberdorfer",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Sheryl",
    "middle": "J.",
    "last_name": "Olson",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Susan",
    "middle": "Lorraine",
    "last_name": "Pagano",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Linda",
    "middle": "",
    "last_name": "Pankratz",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Douglas",
    "middle": "Alan",
    "last_name": "Payne",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Janice",
    "middle": "Lynn",
    "last_name": "Pearson",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Bruce",
    "middle": "H.",
    "last_name": "Peterson",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Paul",
    "middle": "J.D.",
    "last_name": "Polcsan",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Zachary",
    "middle": "",
    "last_name": "Riddle",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Sharon",
    "middle": "L.",
    "last_name": "Riniker",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Linda",
    "middle": "",
    "last_name": "Ruffing",
    "school": "East",
    "": ""
  },
  {
    "first_name": "David",
    "middle": "Randall",
    "last_name": "Schreyer",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Kathy",
    "middle": "",
    "last_name": "Schroetter",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Carol",
    "middle": "",
    "last_name": "Sickel",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Carol",
    "middle": "Lynne",
    "last_name": "Smith",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Douglas",
    "middle": "Clifford",
    "last_name": "Smith",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Robert",
    "middle": "L.",
    "last_name": "Smith",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Barbara",
    "middle": "",
    "last_name": "Snell",
    "school": "East",
    "": ""
  },
  {
    "first_name": "William",
    "middle": "J.",
    "last_name": "Snyder Jr.",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Kyle",
    "middle": "Edward",
    "last_name": "Stolarick",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Colleen",
    "middle": "Ann",
    "last_name": "Sullivan",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Linda",
    "middle": "Ann",
    "last_name": "Templeton",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Dolores",
    "middle": "A.",
    "last_name": "Thomas",
    "school": "East",
    "": ""
  },
  {
    "first_name": "E.",
    "middle": "Ruthann",
    "last_name": "Tomlinson",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Joseph",
    "middle": "James",
    "last_name": "Volk",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Todd",
    "middle": "A.",
    "last_name": "Volpe",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Susanne",
    "middle": "J.",
    "last_name": "Walsh",
    "school": "East",
    "": ""
  },
  {
    "first_name": "David",
    "middle": "W.",
    "last_name": "West",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Holly",
    "middle": "Dianna",
    "last_name": "Whitebread",
    "school": "East",
    "": ""
  },
  {
    "first_name": "William",
    "middle": "F.",
    "last_name": "Whitenack",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Judy",
    "middle": "Ann",
    "last_name": "Williams",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Linda",
    "middle": "A.",
    "last_name": "Wood",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Muriel",
    "middle": "P.",
    "last_name": "Wood",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Janet",
    "middle": "A.",
    "last_name": "Wullert",
    "school": "East",
    "": ""
  },
  {
    "first_name": "Karen",
    "middle": "M.",
    "last_name": "Young",
    "school": "East",
    "": ""
  }
]

export default students